import reducer from "./reducer";

export default reducer;

export { fetchSession, updateDebitor, updateLanguage, logoutSession } from "./actions";

// selectors
export {
  // session
  getIsSessionSyncing,
  getCXmlSessionData,
  // debitor
  getAvailableDebitors,
  getSelectedDebitor,
  // language
  getAvailableLanguages,
  getSelectedLanguage,
  // user
  getUserLogin,
  getUserDisplayName,
  getPermissions,
  getSessionFlags,
  getShowContact,
  getShowFeedback,
  getIsLoggedIn,
  // getIsOciSession,
  getIsOpenShop,

  // features for industry
  getIndustry,
  getIndustryFeatures,
  getShowFavList
} from "./selectors";
